/* eslint-disable no-magic-numbers, no-underscore-dangle */
import * as types from '../../../../store/mutation-types';

const PROJECTS_TO_SCROLL = 3;
const LIST_ITEM_HEIGHT = 65;

export default {
  props: ['foundation', 'activeProject', 'opened'],
  data() {
    return {
      projectsScrolledUpCount: 0,
    };
  },
  computed: {
    transformString() {
      return `translateY(-${this.projectsScrolledUpCount * LIST_ITEM_HEIGHT}px)`;
    },
    showScrollArrows() {
      return this.listItemCount * LIST_ITEM_HEIGHT > window.innerHeight - LIST_ITEM_HEIGHT;
    },
    maxScrolledUp() {
      return this.projectsScrolledUpCount === 0;
    },
    maxScrolledDown() {
      return this.projectsScrolledUpCount === this.listItemCount - 1;
    },
    modalOpen() {
      return this.$store.state.ui.projectImagesModalOpen;
    },
    projectGroupsWithProjects() {
      return this.$store.getters.projectGroupsWithProjects;
    },
    projectsNotInAGroupAsArray() {
      return this.$store.getters.projectsNotInAGroupAsArray;
    },
    listItemCount() {
      let count = this.projectsNotInAGroupAsArray.length;
      this.projectGroupsWithProjects.forEach(group => {
        count++;
        if (group.open) {
          count += group.projects.length;
        }
      });

      return count;
    },
  },
  methods: {
    open() {
      this.$emit('open');
    },
    scrollUp() {
      this.projectsScrolledUpCount = Math.max(this.projectsScrolledUpCount - PROJECTS_TO_SCROLL, 0);
    },
    scrollDown() {
      this.projectsScrolledUpCount = Math.min(this.projectsScrolledUpCount + PROJECTS_TO_SCROLL,
        this.listItemCount - 1);
    },
    setActiveProject(projectId) {
      this.$store.commit(types.SET_ACTIVE_PROJECT_ID, projectId);
    },
    toggle(group) {
      this.$store.dispatch('toggleProjectGroup', group.id);
    },
  },
};
